import {
  SET_LEADS,
  ADD_LEAD,
  UPDATE_LEAD_DATA,
  SET_BOOKINGS,
  UPDATE_LEADS_DATA,
  UPDATE_BOOKING,
  DELETE_LEADS,
  SET_LEADS_FILTERS,
  SET_NEW_LEADS,
  SET_LEADS_PAGINATION,
  SET_FOLLOW_UP_LEADS,
} from "../actions/types";

const initialState = {
  leads: [],
  newLeads: {},
  followUpLeads: {},
  bookings: [],
  leadsIndex: {},
  filters: {},
  leadsPagination: {},
  newLeadsPagination: {},
  followUpLeadsPagination: {},
};

const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_LEADS: {
      let newLeads = action.data.results.reduce((obj, lead) => {
        obj[lead.id + "-lead"] = lead;
        return obj;
      }, {});
      return {
        ...state,
        newLeads,
        newLeadsPagination: action.data.pagination || {},
      };
    }
    case SET_FOLLOW_UP_LEADS: {
      let followUpLeads = action.data.results.reduce((obj, lead) => {
        obj[lead.id + "-lead"] = lead;
        return obj;
      }, {});
      return {
        ...state,
        followUpLeads,
        followUpLeadsPagination: action.data.pagination || {},
      };
    }
    case SET_LEADS: {
      let leadsIndex = action.data.reduce((obj, lead, idx) => {
        obj[lead.id] = idx;
        return obj;
      }, {});
      return {
        ...state,
        leads: action.data,
        leadsIndex,
      };
    }
    case SET_BOOKINGS: {
      return {
        ...state,
        bookings: action.data,
      };
    }
    case SET_LEADS_PAGINATION: {
      return {
        ...state,
        leadsPagination: action.data,
      };
    }
    case SET_LEADS_FILTERS: {
      return {
        ...state,
        filters: action.data,
      };
    }
    case DELETE_LEADS: {
      let deleteIds = action.data.lead_ids.reduce((obj, id) => {
        obj[id] = id;
        return obj;
      }, {});
      let updatedLeads = state.leads.map((lead) => {
        if (deleteIds[lead.id]) {
          lead.is_deleted = true;
        }
        return lead;
      });
      return {
        ...state,
        leads: updatedLeads,
      };
    }
    // case DELETE_LEADS: {
    //   action.data.lead_ids.map((id) => {
    //     if (state.followUpLeads[id + "-lead"]) {
    //       state.followUpLeads[id + "-lead"].is_deleted = true;
    //     }
    //     if (state.newLeads[id + "-lead"]) {
    //       state.newLeads[id + "-lead"].is_deleted = true;
    //     }
    //   });
    //   return {
    //     ...state,
    //     followUpLeads: { ...state.followUpLeads },
    //     newLeads: { ...state.newLeads },
    //   };
    // }
    case UPDATE_BOOKING: {
      let updatedBookings = [...state.bookings];
      let bookingIndx = updatedBookings.findIndex(
        (booking) => booking.id == action.data.id
      );
      if (bookingIndx >= 0) {
        updatedBookings[bookingIndx] = {
          ...updatedBookings[bookingIndx],
          ...action.data,
        };
      }
      return {
        ...state,
        bookings: updatedBookings,
      };
    }
    case ADD_LEAD: {
      let updatedLeads = [action.data, ...state.leads];
      let leadsIndex = updatedLeads.reduce((obj, lead, idx) => {
        obj[lead.id] = idx;
        return obj;
      }, {});
      return {
        ...state,
        leads: updatedLeads,
        leadsIndex,
      };
    }
    // case ADD_LEAD: {
    //   const isNewLead = action.data.status?.status == "New Lead";

    //   let newLeads = { ...state.newLeads };
    //   let followUpLeads = { ...state.followUpLeads };

    //   if (isNewLead) {
    //     newLeads = {
    //       [action.data.id + "-lead"]: action.data,
    //       ...state.newLeads,
    //     };
    //   } else {
    //     followUpLeads = {
    //       [action.data.id + "-lead"]: action.data,
    //       ...state.followUpLeads,
    //     };
    //   }
    //   return {
    //     ...state,
    //     newLeads,
    //     followUpLeads,
    //   };
    // }
    case UPDATE_LEAD_DATA: {
      let updatedLeads = [...state.leads];
      let leadIndx = updatedLeads.findIndex(
        (lead) => lead.id == action.data.id
      );
      if (leadIndx >= 0) {
        updatedLeads[leadIndx] = {
          ...updatedLeads[leadIndx],
          ...action.data,
        };
      }
      return {
        ...state,
        leads: updatedLeads,
      };
    }
    // case UPDATE_LEAD_DATA: {
    //   const leadId = action.data.id;
    //   const isNewLead = action.data.status?.status == "New Lead";

    //   if (isNewLead) {
    //     let newLeads = { ...state.newLeads };
    //     newLeads[leadId + "-lead"] = {
    //       ...newLeads[leadId + "-lead"],
    //       ...action.data,
    //     };
    //     return {
    //       ...state,
    //       newLeads,
    //     };
    //   }

    //   let followUpLeads = { ...state.followUpLeads };

    //   followUpLeads[leadId + "-lead"] = {
    //     ...followUpLeads[leadId + "-lead"],
    //     ...action.data,
    //   };

    //   return {
    //     ...state,
    //     followUpLeads,
    //   };
    // }
    case UPDATE_LEADS_DATA: {
      let updatedLeads = [...state.leads];
      action.data.map((lead) => {
        let leadIndex = state.leadsIndex[lead.id];
        if (leadIndex != undefined) {
          updatedLeads[leadIndex] = lead;
        }
      });
      return {
        ...state,
        leads: updatedLeads,
      };
    }
    // case UPDATE_LEADS_DATA: {
    //   action.data.map((lead) => {
    //     if (state.followUpLeads[lead.id + "-lead"]) {
    //       state.followUpLeads[lead.id + "-lead"] = lead;
    //     }
    //     if (state.newLeads[lead.id + "-lead"]) {
    //       state.newLeads[lead.id + "-lead"] = lead;
    //     }
    //   });
    //   return {
    //     ...state,
    //     followUpLeads: { ...state.followUpLeads },
    //     newLeads: { ...state.newLeads },
    //   };
    // }
    default:
      return state;
  }
};

export default leadReducer;
